<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/newrankingmanage/select"
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      @openAddDialog="openAddDialog"
      addShowPower="/newrankingmanage/add"
    >
      <el-form-item label="活动时间">
        <el-date-picker
          v-model="time"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="formModel.status">
          <el-option
            v-for="item in status"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="gameName"
        label="排行榜名称"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="rankType"
        label="类型"
        min-width="120"
        :formatter="formatterTableRankStatus"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="topNumber"
        label="App显示排名"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="startTime"
        label="活动时间"
        min-width="350"
        :formatter="formatterTableData"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.startTime }} ~ {{ scope.row.endTime }}
        </template>
      </el-table-column>
      <el-table-column prop="logoUrl" label="logo" min-width="120">
        <template slot-scope="scope">
          <image-viewer
            class="iconUrl"
            :src="scope.row.logoUrl"
            alt="图片描述"
          ></image-viewer>
        </template>
      </el-table-column>
      <el-table-column
        prop="integralYj"
        label="业绩积分(积分/元)"
        min-width="140"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="integral199"
        label="押金199(分)"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="integral299"
        label="押金299(分)"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        min-width="120"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            active-color="#13ce66"
            inactive-color="#ff4949"
            :active-value="1"
            :inactive-value="0"
            @change="statusturns($event, scope.row)"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        min-width="180"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="updateTime"
        label="修改时间"
        min-width="180"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        v-if="hasPerm('/newrankingmanage/caozuo')"
        label="操作"
        min-width="120"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button type="text" @click="openAddDialog(scope.row)"
            >修改
          </el-button>
          <el-button type="text" @click="handleDelete(scope.row)"
            >删除
          </el-button>
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      :formDialogTitle="itemId ? '修改' : '添加'"
      :model="dialogModel"
      :submitData="dialogData"
      :rules="dialogRules"
      :dialogService="dialogService"
      @close="dialogClose"
      @success="dialogSuccess"
      class="note"
      labelWidth="120px"
      dialogWidth="800px"
    >
      <div style="display: flex">
        <el-form-item label-width="127px" label="排行榜名称" prop="gameName">
          <el-input
            type="text"
            v-model="dialogModel.gameName"
            placeholder="请输入"
            style="width: 180px"
          ></el-input>
        </el-form-item>
        <el-form-item label="App显示排名" prop="topNumber">
          <el-input-number
            v-model="dialogModel.topNumber"
            :min="3"
            :max="999999999"
            :step="0"
            :precision="0"
            :controls="false"
            placeholder="请输入"
          ></el-input-number>
        </el-form-item>
      </div>
      <el-form-item label-width="120px" label="logo" prop="logoUrl">
        <el-upload
          class="avatar-uploader"
          :action="uploadUrl + '8883/picture/upload'"
          :data="commonParams"
          name="picture"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
        >
          <img
            v-if="dialogModel.logoUrl"
            :src="dialogModel.logoUrl"
            class="avatar"
          />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label-width="119px" label="活动时间" prop="huodongtime">
        <el-date-picker
          style="width: 500px"
          v-model="dialogModel.huodongtime"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="类型" prop="rankType">
        <el-select
          clearable
          v-model="dialogModel.rankType"
          style="width: 198px"
        >
          <el-option
            v-for="item in gettype"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <div style="display: flex" v-if="dialogModel.rankType == 'jh'">
        <el-form-item
          label-width="127px"
          label="押金199(分)"
          prop="integral199"
        >
          <el-input-number
            style="width: 180px"
            v-model="dialogModel.integral199"
            :min="0"
            :max="999999999"
            :step="0"
            :precision="0"
            :controls="false"
            placeholder="请输入"
          ></el-input-number>
        </el-form-item>
        <el-form-item
          label-width="116px"
          label="押金299(分)"
          prop="integral299"
        >
          <el-input-number
            style="width: 180px"
            v-model="dialogModel.integral299"
            :min="0"
            :max="999999999"
            :step="0"
            :precision="0"
            :controls="false"
            placeholder="请输入"
          ></el-input-number>
        </el-form-item>
      </div>
      <div v-if="dialogModel.rankType == 'yj'">
        <el-form-item
          label-width="154px"
          label="业绩积分(积分/元)"
          prop="integralYj"
        >
          <el-input-number
            style="width: 180px"
            v-model="dialogModel.integralYj"
            :min="0"
            :max="999999999"
            :step="0"
            :precision="0"
            :controls="false"
            placeholder="请输入"
          ></el-input-number>
        </el-form-item>
      </div>
      <div>
        <el-button
          type="primary"
          size="small"
          @click="AddLevelItem"
          style="margin-bottom: 20px"
          >添加
        </el-button>
        <div
          class="flex-row vertical-center"
          v-for="(item, index) in dialogModel.awardListStr"
          :key="index"
        >
          <div style="display: flex">
            <el-form-item
              label="排名"
              label-width="127px"
              :prop="'awardListStr.' + index + '.rank'"
            >
              <el-input-number
                disabled
                v-model="item.rank"
                :min="1"
                :max="999999999"
                :step="0"
                :precision="0"
                :controls="false"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
            <el-form-item
              label="奖励金额(元)"
              :prop="'awardListStr.' + index + '.awardAmt'"
              label-width="116px"
              :rules="awardAmt"
            >
              <el-input-number
                v-model="item.awardAmt"
                :min="0"
                :max="999999999"
                :step="2"
                :precision="2"
                :controls="false"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
            <el-button
              @click.prevent="RemoveLevelItem(item)"
              style="margin-bottom: 20px"
              v-if="
                dialogModel.awardListStr.length > 1 &&
                index === dialogModel.awardListStr.length - 1
              "
            >
              删除
            </el-button>
          </div>
        </div>
      </div>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";
import ImageViewer from "../../dialog/ImageViewer";

import APPService from "service/APPService";

import Server from "common/conf/Server";
import privateKey from "service/constant/privateKey";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "newrankingmanage",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
    ImageViewer,
  },
  data() {
    return {
      time: "",
      uploadUrl: Server[process.env.NODE_ENV],
      show: false,
      formModel: {
        status: "",
      },
      tableData: [],
      submitService: APPService.newrankingmanageList,
      page: {},
      isPage: false,
      itemId: "",
      dialogModel: {
        gameName: "",
        topNumber: undefined,
        logoUrl: "",
        huodongtime: [],
        integral199: undefined,
        integral299: undefined,
        integralYj: undefined,
        rankType: "",
        awardListStr: [
          {
            rank: 1,
            awardAmt: undefined,
          },
        ],
      },
      status: [
        {
          dictKey: "",
          dictValue: "全部",
        },
        {
          dictKey: "0",
          dictValue: "关闭",
        },
        {
          dictKey: "1",
          dictValue: "开启",
        },
      ],
      gettype: [],
      pickerOptions: {
        disabledDate(time) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          const date = new Date(time);
          date.setHours(0, 0, 0, 0);
          return date < today;
        },
      },
      dialogRules: {
        gameName: [
          {
            required: true,
            message: "请输入",
          },
        ],
        topNumber: [
          {
            required: true,
            message: "请输入",
          },
        ],
        huodongtime: [
          {
            required: true,
            message: "请选择",
          },
        ],
        rankType: [
          {
            required: true,
            message: "请选择",
          },
        ],
        logoUrl: [
          {
            required: true,
            message: "请选择你要上传的图片",
          },
        ],
        integral199: [
          {
            required: true,
            message: "请输入",
          },
        ],
        integral299: [
          {
            required: true,
            message: "请输入",
          },
        ],
        integralYj: [
          {
            required: true,
            message: "请输入",
          },
        ],
      },
      awardAmt: [
        {
          required: true,
          message: "请输入",
        },
      ],
      isFlag: false,
      checkAll: false,
      checkedCities: [],
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.load();
  },
  computed: {
    submitData() {
      if (this.time == null || this.time == "") {
        this.time = [];
      }
      this.params = {
        status: this.formModel.status,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      if (this.time.length) {
        this.params.startTime = this.time[0];
        this.params.endTime = this.time[1];
      }
      return this.params;
    },
    dialogData() {
      if (
        this.dialogModel.huodongtime == null ||
        this.dialogModel.huodongtime == ""
      ) {
        this.dialogModel.huodongtime = [];
      }
      const params = {
        gameName: this.dialogModel.gameName,
        topNumber: this.dialogModel.topNumber,
        logoUrl: this.dialogModel.logoUrl,
        integral199: this.dialogModel.integral199,
        integral299: this.dialogModel.integral299,
        integralYj: this.dialogModel.integralYj,
        rankType: this.dialogModel.rankType,
        awardListStr: JSON.stringify(this.dialogModel.awardListStr),
      };
      if (this.dialogModel.huodongtime.length) {
        params.startTime = this.dialogModel.huodongtime[0];
        params.endTime = this.dialogModel.huodongtime[1];
      }
      if (this.itemId) {
        params.id = this.itemId;
      }
      console.log(params);
      return params;
    },
    dialogService() {
      return APPService.newrankingmanageUpdate;
    },
    commonParams() {
      const params = {
        serverType: this.serverType,
        tatId: this.tatId,
        reqTime: new Date().format("yyyy-MM-dd HH:mm:ss"),
      };
      params.sign = encrypt(
        urlEncode(objKeySort(params)) + "&priKey=" + privateKey.priKey
      );
      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  watch: {
    "dialogModel.rankType"(val, oldval) {
      switch (val) {
        case "yj":
          this.dialogModel.integral199 = 0;
          this.dialogModel.integral299 = 0;
          break;
        case "jh":
          this.dialogModel.integralYj = 0;
          break;
        default:
          this.dialogModel.integral199 = 0;
          this.dialogModel.integral299 = 0;
          this.dialogModel.integralYj = 0;
          break;
      }
    },
  },
  methods: {
    load() {
      this.formModel = {
        status: "",
      };
      this.page = this.$refs.commonTable.page;
      this.getList();
      this.getgettype();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    handleDelete(item) {
      this.showConfirm("是否删除？")
        .then(() => {
          this.doDelete(item.id);
        })
        .catch(() => {});
    },
    doDelete(id) {
      this.doLoad(
        APPService.newrankingmanageDel,
        {
          id: id,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    statusturns($event, scope) {
      this.doStatus($event, scope);
    },
    doStatus($event, scope) {
      this.doLoad(
        APPService.newrankingmanageStatus,
        {
          id: scope.id,
          status: $event,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    openAddDialog(item, flag) {
      this.itemId = item ? item.id : "";
      if (this.itemId) {
        this.isFlag = true;
        this.getdetail(this.itemId);
      }
      this.$refs.formDialog.open();
    },
    getdetail(id) {
      this.doLoad(
        APPService.newrankingmanageDetail,
        {
          id: id,
        },
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.dialogModel = JSON.parse(JSON.stringify(result));
            this.$set(this.dialogModel, "huodongtime", [
              this.dialogModel.startTime,
              this.dialogModel.endTime,
            ]);
            this.dialogModel.awardListStr = [];
            if (result.awardList) {
              for (let i = 0; i < result.awardList.length; i++) {
                this.dialogModel.awardListStr.push({
                  rank: result.awardList[i].rank,
                  awardAmt: result.awardList[i].awardAmt,
                });
              }
            } else {
              this.dialogModel.awardListStr.push({
                rank: 1,
                awardAmt: undefined,
              });
            }
          });
        },
        "信息获取失败"
      );
    },
    AddLevelItem() {
      const newItem = {
        rank: this.dialogModel.awardListStr.length + 1,
        awardAmt: undefined,
      };
      this.dialogModel.awardListStr.push(newItem);
    },
    RemoveLevelItem(item) {
      this.showConfirm("确定要删除此行？")
        .then(() => {
          let index = this.dialogModel.awardListStr.indexOf(item);
          if (index !== 0) {
            this.dialogModel.awardListStr.splice(index, 1);
          }
        })
        .catch(() => {});
    },
    getgettype() {
      this.doLoad(
        APPService.newrankingmanagegettype,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.gettype = res.contents;
          });
        },
        "信息获取失败"
      );
    },
    dialogClose() {
      this.dialogModel = {
        gameName: "",
        topNumber: undefined,
        logoUrl: "",
        huodongtime: [],
        integral199: undefined,
        integral299: undefined,
        integralYj: undefined,
        rankType: undefined,
        awardListStr: [
          {
            rank: 1,
            awardAmt: undefined,
          },
        ],
      };
      this.itemId = "";
    },
    dialogSuccess(res) {
      this.commonSuccess(res);
      this.$refs.formDialog.closeDialog();
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    handleAvatarSuccess(res, file) {
      this.doCheck(res, (res) => {
        this.dialogModel.logoUrl = res.contents;
      });
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        return isLt2M;
      }
      return isLt2M;
    },
    formatterTableRankStatus(row, column, cellValue, index) {
      let value = "";
      this.gettype.forEach((item) => {
        if (item.code == cellValue) {
          value = item.name;
        }
      });
      return value ? value : "--";
    },
  },
};
</script>

<style scoped>
.button {
  width: 50px;
  padding: 11px 10px;
  margin-left: 49px;
  display: block;
  float: left;
}

.text {
  width: 145px !important;
  margin-left: 12px;
  float: left;
}

.mem-name p {
  margin-bottom: 20px;
  vertical-align: middle;
  line-height: 40px;
  color: rgba(170, 170, 170, 1);
}

.mem-name p:first-child {
  display: inline-block;
  width: 90px;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
}
.chenk {
  width: 60px;
  position: relative;
  top: -61px;
  left: 189px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.iconUrl {
  width: 50px;
  height: 50px;
  margin: auto;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/view/page/NewRankIng/NewRankIngManage.vue